function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.0901 0.952759H16.8043L10.8745 7.73023L17.8505 16.9528H12.3874L8.10935 11.3594L3.21415 16.9528H0.498225L6.84085 9.70356L0.149506 0.952759H5.74948L9.61658 6.06535L14.0901 0.952759ZM13.1374 15.3281H14.6414L4.93313 2.49208H3.31914L13.1374 15.3281Z",
    fill: "#8B8A9E",
    style: {
      fill: "#8B8A9E",
      fill: "color(display-p3 0.5451 0.5412 0.6196)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitter);
export default __webpack_public_path__ + "static/media/XTwitter.407261f3cdd5344ab64b9069bda87e6b.svg";
export { ForwardRef as ReactComponent };